export const makeNotification = ({ theme, type }) => {
    return `color: #FFFF;
          background-color: ${type === 'error' ? theme.colors.danger.normal : theme.colors.secondary.normal};
          border-radius: 8px;
          position: fixed;
          bottom: 30px;
          left: 16px;
          right: 16px;

          @media (min-width: ${theme.screen.smMin}){
            bottom: 44px;
            left: auto;
            right: 44px;
          }

          align-items: center;
          justify-content: center;
          display: flex;
          padding: 0px 16px;
          line-height: 48px;`;
};
export const makeErrorIcon = () => {
    return `margin-right: 20px;`;
};
export const makeSuccesIconNotification = () => {
    return `margin-left: 20px;`;
};
